import React from "react";
import { PaperProvider } from "react-native-paper";
import { SafeAreaProvider } from "react-native-safe-area-context";

import type { ExtendedTheme } from "../theme/SynapseTheme";
import ErrorBoundary from "./ErrorBoundary";

/**
 * Root providers. The error boundary sits above PaperProvider: Paper renders
 * Portal content (every modal) as a sibling of its children, so a boundary
 * inside PaperProvider never sees a modal's render error.
 */
export const AppProviders: React.FC<{
  theme: ExtendedTheme;
  children: React.ReactNode;
}> = ({ theme, children }) => (
  <ErrorBoundary>
    <PaperProvider theme={theme}>
      <SafeAreaProvider>{children}</SafeAreaProvider>
    </PaperProvider>
  </ErrorBoundary>
);
